export default "__VITE_ASSET__BqbNZN7c__"